(function($) {
	formHelper.addRule({
		form: '.form-account-register',
		status: {
			SUCCESS: function() {

				this.redirect(this.data.redirectTo);
			},
			ERROR: function() {

				if (typeof turnstile !== 'undefined') {

					turnstile.reset('#my-turnstile');
				}

				if (this.data && this.data.errorMessage) {

					$('#system-message-1').html(this.data.errorMessage);
				}
			}
		}
	});
})(jQuery);

// Shared functionality below - form fields can be found at /myaccount/templatesInstallation.xsl
jQuery(function initHandleAccountRegisterForm($) {

	$('.form-installation-wrapper').each(function(index, el) {

		var previouslySelectedOption = $('#account-installation').val();

		var initializeInstallations = function() {

			checkInstallation();
		};

		var checkInstallation = function() {

			// AJAX call to load the passed in Branch Name to display installation Reference values / Installation Number
			var id = $('.js-account-branch-action').val();
			previouslySelectedOption = $('#account-installation').val();
			$('#account-installation').prop('disabled', true);

			$.ajax({
				method: 'POST',
				url: '/h/myaccount/getInstallationOptionsByBranch',
				dataType: 'html',
				data: { id: id },
			})
			.done(function( data ) {

				$('#account-installation').html(data);
				$('#account-installation').prop('disabled', false);

				if (previouslySelectedOption !== '' && $("#account-installation option[value='" + previouslySelectedOption + "']").length > 0) {
					$("#account-installation option[value='" + previouslySelectedOption + "']").prop('selected', true);
					var selectedValue = $('#account-installation option:selected').text();
					$('#account-installation-ref').val(selectedValue);
				}
			})
			.fail(function() {

				alert( "An unexpected error has occurred." );
				$('#account-installation').prop('disabled', false);
			});
		};
		
		$('.js-account-branch-action').change(function() {

			checkInstallation();
		});

		$('#account-installation').change(function() {

			// Pull the select selected list value and put into hidden text box for submission
			if($(this).val() !== '') {
				var selectedValue = $('#account-installation option:selected').text();
				$('#account-installation-ref').val(selectedValue);
			}
		});

		// Only initialize the form to check account branch for sites with branches
		var initialBranchValue = $('#account-branch').val();

		if (initialBranchValue !== 'N') {

			initializeInstallations();
		}
	});
});